// material-ui
import { Badge } from '@mui/material';

// project imports
import AvatarStatus from './AvatarStatus';
import { User } from '../../graphql/types';
import ProfileAvatar from '../profiles/ProfileAvatar';

// ==============================|| CHAT USER AVATAR WITH STATUS ICON ||============================== //

interface UserAvatarProps {
  user: User;
  showBadge?: boolean;
  useCompactViewStyle?: boolean | null;
}

const UserAvatar = ({ user, showBadge = true, useCompactViewStyle = false }: UserAvatarProps) => (
  <Badge
    overlap="circular"
    badgeContent={showBadge && <AvatarStatus status={user?.isActive ? 'available' : 'do_not_disturb'} />}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right'
    }}
    sx={{
      '& .MuiBadge-badge': {
        top: useCompactViewStyle ? 5 : undefined
      },
      '& .MuiBox-root': { width: 6, height: 6 },
      padding: 0,
      minWidth: 12,
      '& svg': { background: '#fff', borderRadius: '50%' }
    }}
  >
    <ProfileAvatar user={user} size={useCompactViewStyle ? 'xs' : 'sm'} />
  </Badge>
);

export default UserAvatar;
